import { IAnalyticsTableColumn } from '../interfaces/IAnalyticsTableColumn';

export const initialAnalyticsTableColumns: IAnalyticsTableColumn[] = [
  {
    id: 'name',
    name: '',
    columnType: 'knoName',
    startSection: false,
  },
  {
    id: 'knmProposedPP',
    name: 'Предложено плановых мероприятий по контролю на текущий год',
    columnType: 'planned',
    startSection: true,
  },
  {
    id: 'knmProposedPPMSP',
    name: 'в отношении МСП',
    columnType: 'planned',
    combinedText: true,
  },
  {
    id: 'knmPublishedPP',
    name: 'Включено в план проверок на текущий год',
    columnType: 'planned',
  },
  {
    id: 'knmPublishedPPMSP',
    name: 'в отношении МСП',
    columnType: 'planned',
    combinedText: true,
  },
  {
    id: 'knmFinishedPP',
    name: 'Проведено плановых проверок',
    columnType: 'planned',
  },
  {
    id: 'knmFinishedPPMSP',
    name: 'в отношении МСП',
    columnType: 'planned',
    combinedText: true,
  },
  {
    id: 'knmFinishedVP',
    name: 'Проведено внеплановых проверок',
    columnType: 'notplanned',
    startSection: true,
  },
  {
    id: 'knmFinishedVPMSP',
    name: 'в отношении МСП',
    columnType: 'notplanned',
    combinedText: true,
  },
  {
    id: 'knmFinishedGovernment',
    name: 'Проведено проверок на основании поручений Президента и Правительства РФ',
    columnType: 'notplanned',
  },
  {
    id: 'knmFinishedGovernmentMSP',
    name: 'в отношении МСП',
    columnType: 'notplanned',
    combinedText: true,
  },
  {
    id: 'knmControlVP',
    name: 'Проведено проверок по контролю за исполнением предписаний',
    columnType: 'notplanned',
  },
  {
    id: 'knmControlVPMSP',
    name: 'в отношении МСП',
    columnType: 'notplanned',
    combinedText: true,
  },
  {
    id: 'knmApproveRequestVP',
    name: 'Поступило заявлений о согласовании проведения внеплановых проверок',
    columnType: 'notplanned',
    startSection: false,
  },
  {
    id: 'knmApproveRequestVPMSP',
    name: 'в отношении МСП',
    columnType: 'notplanned',
    combinedText: true,
  },
  {
    id: 'knmApprovedVP',
    name: 'Согласовано с прокурором',
    columnType: 'notplanned',
  },
  {
    id: 'knmApprovedVPMSP',
    name: 'в отношении МСП',
    columnType: 'notplanned',
    combinedText: true,
  },
  {
    id: 'knmRejectVp',
    name: 'Отказано в согласовании',
    columnType: 'notplanned',
  },
  {
    id: 'knmRejectVpMSP',
    name: 'в отношении МСП',
    columnType: 'notplanned',
    combinedText: true,
  },
  {
    id: 'fullFilledOutOfTime',
    name: 'Основные сведения, заполненные несвоевременно',
    columnType: 'violations',
    startSection: true,
  },
  {
    id: 'resultOutOfTime',
    name: 'Результат проведения отсутствует или внесен с опозданием',
    columnType: 'violations',
    startSection: false,
  },
];
